<div class="map-buttons" *ngIf="!isNative">
  <button type="button" class="cnt-button" (click)="close.emit()">
    <div class="cnt-button-copy">
      {{ text }}
    </div>
  </button>

  <button type="button" class="cnt-button close-map" (click)="close.emit()">
    <div class="cnt-button-copy">
      <i class="icon-cnt-times"></i>
    </div>
  </button>
</div>
<div class="map-square">
  <div #mapContainer class="square-map-container">
    <curbnturf-open-street-map
      #openStreetMap
      [lat]="location?.lat ?? DEFAULT_MAP_LATITUDE"
      [lon]="location?.lon ?? DEFAULT_MAP_LONGITUDE"
      [zoom]="zoom"
      [draggable]="draggable"
      (mapTapped)="newPosition($event)"
      type="satellite"
    >
    </curbnturf-open-street-map>
    <pre></pre>
    <button type="button" *ngIf="!isNative" class="done-button close-map cnt-button" (click)="close.emit()">
      <div class="cnt-button-copy">Done</div>
    </button>
  </div>
</div>
